module.exports = __webpack_public_path__ + "static/tara-logo-en-9fc057151510bcb305c0ed243080316e.svg";